// extracted by mini-css-extract-plugin
export var divider = "_u3-0";
export var systemMessage = "_u3-1";